import { apiUnauthenticated } from './client';
import type { operations } from './generated/openapi';

export type AppUpdateInfo = operations['appUpdateManifest']['responses'][200]['content']['application/json'];
export type UpdatePlatform = 'android' | 'desktop';

export function getAppUpdate(platform: UpdatePlatform): Promise<AppUpdateInfo> {
  return apiUnauthenticated('/app/update?platform=' + platform);
}

export function updateHistory(info: AppUpdateInfo): AppUpdateInfo['history'] {
  return info.history?.length ? info.history : info.latest.trim()
    ? [{ version: info.latest, date: '', notes: info.notes }]
    : [];
}
